module.exports = __webpack_public_path__ + "assets/img/logo.cef74a60.png";